<template>
  <div :class="`grey--text text-xs-${align}`">
    <div class="grey--text text--darken-1 body-2">{{title}}</div>
    {{value || '-'}}
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    value: String,
    align: String
  }
};
</script>

<style>
</style>
